export function SkipLink(props: {label: string, anchor: string}){
  return <a href={props.anchor} role="menuitem" className="skip"><span>{props.label}</span></a>;
}